<template>
    <div class="dashboard_welcome">
        Welcome to your dashboard
    </div>
</template>

<script>
    export default {
        name: "main"
    }
</script>

<style scoped>

</style>